import {
  StatusRow,
  StyledStatusButton,
} from "@/containers/Project/components/ProjectHeader/styled";
import { Col, Tooltip } from "antd";
import { useIntl } from "react-intl";

interface IProps {
  status: { id: string; label: string };
  handleChangeStatus: () => void;
  disabled: boolean;
  showStatusHoverMessage: boolean;
}

export const StatusButton = ({
  status,
  handleChangeStatus,
  disabled,
  showStatusHoverMessage,
}: IProps) => {
  const intl = useIntl();

  return (
    <Tooltip
      title={
        showStatusHoverMessage
          ? intl.formatMessage({
              id: "changeStatusModal.contactAdmin",
            })
          : ""
      }
    >
      <StyledStatusButton
        type="text"
        data-test-id="projects-status-button"
        $status={status.id}
        onClick={handleChangeStatus}
        disabled={disabled}
      >
        <Col>
          <StatusRow justify="center">
            {intl.formatMessage({ id: "project.statusButtonLabel" })}
          </StatusRow>
          <StatusRow justify="center">{status.label.toUpperCase()}</StatusRow>
        </Col>
      </StyledStatusButton>
    </Tooltip>
  );
};
